export default "__VITE_ASSET__MbZE4_V9__"